import { useMediaQuery } from '@vueuse/core'

const MediaQueries = {
  IS_MOBILE: '(max-width: 767px)',
  IS_TABLET_ONLY: '(min-width: 768px) and (max-width: 1023px)',
  IS_TABLET: '(max-width: 1023px)',
  IS_TABLET_MEDIUM: '(max-width: 987px)',
  IS_LAPTOP: '(min-width: 1024px) and (max-width: 1279px)',
  IS_DESKTOP_SMALL: '(min-width: 1024px)',
  IS_DESKTOP_MEDIUM: '(max-width: 1279px)',
  FROM_DESKTOP_MEDIUM: '(min-width: 1279px)',
} as const

export const useScreenSize = defineStore('screenSize', () => {
  const isMobile = computed(() => {
    return useMediaQuery(MediaQueries.IS_MOBILE).value
  })
  const isTabletOnly = computed(() => {
    return useMediaQuery(MediaQueries.IS_TABLET_ONLY).value
  })
  const isTablet = computed(() => {
    return useMediaQuery(MediaQueries.IS_TABLET).value
  })
  const isTabletMedium = computed(() => {
    return useMediaQuery(MediaQueries.IS_TABLET_MEDIUM).value
  })
  const isLaptop = computed(() => {
    return useMediaQuery(MediaQueries.IS_LAPTOP).value
  })

  const isDesktopSmall = computed(() => {
    return useMediaQuery(MediaQueries.IS_DESKTOP_SMALL).value
  })
  const isDesktopMedium = computed(() => {
    return useMediaQuery(MediaQueries.IS_DESKTOP_MEDIUM).value
  })
  const fromDesktopMedium = computed(() => {
    return useMediaQuery(MediaQueries.FROM_DESKTOP_MEDIUM).value
  })
  const $reset = () => ({})
  return {
    isMobile,
    isTabletOnly,
    isTablet,
    isTabletMedium,
    isLaptop,
    isDesktopSmall,
    isDesktopMedium,
    fromDesktopMedium,
    $reset,
  }
})
